import toast from "@/templates/_lib/simple-notify";
import A11yDialog from "a11y-dialog";

export default class AccountManagementComponent extends HTMLElement {
  
    // private _editButtonTrigger : HTMLElement;
    // private _mobileDropdownTrigger: HTMLElement;
    // private _dashboardView: HTMLElement;
    private modalContainer: HTMLElement;
    // private modalShareContainer: HTMLElement;
    private modal: A11yDialog;
    // private shareModal: A11yDialog;
    // private _drawerBackdrop: HTMLElement;
    // private _closeDrawer: HTMLElement;
    // private _stickyContainer: HTMLElement;
    
    constructor() {
        super();
        // this._editButtonTrigger = document.querySelector('.edit-button-trigger');
        // this._mobileDropdownTrigger = document.querySelector('mobile-dropdown-trigger');
        // this._dashboardView = document.querySelector('dashboard-info');
        this.modalContainer = document.getElementById('dashboard-dialog');
        // this.modalShareContainer = document.getElementById('share-dialog');
        this.modal = new A11yDialog(this.modalContainer);
        // this.shareModal = new A11yDialog(this.modalShareContainer);
        // this._drawerBackdrop = document.querySelector('.drawer-backdrop');
        // this._closeDrawer = document.querySelector('.close-drawer');
        // this._stickyContainer = document.querySelector('sticky-content-container');
    }

    private loadDeleteModal () {
        this.modal
        .on('show', this.showModal)
        .on('hide', this.hideModal);
    }
    
   
  
    private showModal = async (e: CustomEvent): Promise<void> => {
        const modal = e.target as HTMLElement;
        const target = e.detail.target;
        const opener = target.closest('[data-a11y-dialog-show]');
        const userId = opener.dataset.userId ?? '';
      
        const response = await fetch(`/ajax/delete-user-modal?user-id=${userId}`);
        const data = await response.text();
        const modalContentContainer = modal.querySelector('#dashboard-dialog-description');
        
        document.documentElement.style.overflowY = 'hidden';
        modalContentContainer.innerHTML = data;
        this.buildForm();

      }
      private hideModal = (e: Event): void => {
        const modal = e.target as HTMLElement;
        const modalContentContainer = modal.querySelector('#dashboard-dialog-description');
        document.documentElement.style.overflowY = '';
        modalContentContainer.innerHTML = '';
      }
      private handleDelete = async () => {
        const formTrigger = document.querySelector('button.delete-confirm') as HTMLElement;
        const actionURL = formTrigger.dataset.actionUrl;
        // const subscriptionTitle = this._deleteButton.dataset.subscriptionTitle;
        
        const params = new FormData();

       // Assuming these are the correct dataset keys
        const csrfTokenName = formTrigger.dataset.csrfTokenName;
        const csrfTokenValue = formTrigger.dataset.csrfTokenValue;
        const userId = formTrigger.dataset.userId;

        // Append each parameter separately
        params.append(csrfTokenName, csrfTokenValue);
        params.append('userId', userId);
         fetch(actionURL, {
             method: 'POST',
             
             headers: {
                 'Accept': 'application/json',
                 'X-Requested-With': 'XMLHttpRequest',
             },
             body: params,
         }).then(response => response.json())
         .then(data => {
             if (data.success) {
                const newUrl = `${window.location.pathname}?showToast=true`;
                history.pushState({}, '', newUrl);
                // Refresh the page
                window.location.reload();
                
             }else {
                const newUrl = `${window.location.pathname}?showToast=false`;
                history.pushState({}, '', newUrl);
                // Refresh the page
                window.location.reload();
                
             }
         });
    }
    
    private buildForm ()  {
        const formTrigger = document.querySelector('button.delete-confirm') as HTMLElement;
        if(formTrigger) {
            formTrigger.addEventListener('click', this.handleDelete.bind(this));
        }
    }
  
    private handleUserForm (e) {
        if(e.detail.value == 'success message') {
            
            toast({
                title: 'Personal Information Updated!',
                status: 'success',
            });
        }
        else {
            toast({
                title: 'Failed to Update',
                status: 'error',
            });
        }
    }
  
  private handleSubscribeTopic(e) {
    if (e.detail.value == 'error') {
      toast({
        title: 'Unable to update subscriptions.',
        status: 'error',
      });
      return;
    }
    
    toast({
      title: 'Successfully updated subscriptions.',
      status: 'success',
    });
  }
    

    connectedCallback() {
        // Needed because we are using HTMX - In the event the user refreshed
        // the page and the formTrigger was not present on their initial load
        
        this.loadDeleteModal();
        document.addEventListener('userForm', this.handleUserForm);
        document.addEventListener('subscribeTopic', this.handleSubscribeTopic);
        
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('showToast') === 'true') {
            // Display the toast notification
            
            toast({
                title: 'Account Deleted',
                status: 'success',
            });
           
           
        }
        else if (urlParams.get('showToast') === 'false') {
            toast({
                title: 'Failed to Delete Account',
                status: 'error',
            });
        }
        const newUrlWithoutToast = window.location.pathname;
        history.replaceState({}, '', newUrlWithoutToast);
    }
}
